import {
  Modal,
  Form,
  Input,
  Select,
  Button,
  message,
  Row,
  Col,
  Card,
  Space,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  HomeOutlined,
  TeamOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { registerUser, getAllCompanies, fetchVersions } from "../../apis";
import "../../styles/admin/admin-dashboard.css";
import "../../styles/admin/admin-tables.css";

const { Option } = Select;

function AddUser({ open, onCancel, refreshUsers }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [showOtherClientInput, setShowOtherClientInput] = useState(false);
  const [showMCVersion, setShowMCVersion] = useState(false);
  const [showSignalFixClient, setShowSignalFixClient] = useState(false);
  const [showSimFixClient, setShowSimFixClient] = useState(false);
  const [showMCClient, setShowMCClient] = useState(false); // New state for Mystery Client client selection
  const [showAllInOneServices, setShowAllInOneServices] = useState(false);

  const [misteryVersion, setMisteryVersion] = useState([]);
  const [permissions] = useState([
    { value: "semafix", label: "SemaFix" },
    { value: "onde_verde", label: "SyncFix" },
    { value: "mystery_client", label: "Mystery Client" },
    { value: "signal_fix", label: "SignalFix" },
    { value: "betwin", label: "BE-Twin - Raise Project" },
    { value: "sim_fix", label: "SimFix" },
    { value: "analysis", label: "Analysis" },
    { value: "Lavagna", label: "Lavagna" },
    { value: "traffix_all_in_one", label: "Traffix All In One" },
    { value: "AIWayport", label: "AIWayport" },
  ]);
  const clientOptions = [
    { value: "ASPO", label: "ASPO" },
    { value: "SETA", label: "SETA" },
    { value: "CTM", label: "CTM" },
    { value: "ATM", label: "ATM" },
    { value: "ATB", label: "ATB" },
    { value: "STPS", label: "STPS" },
    { value: "SGM", label: "SGM" },
    { value: "TPER", label: "TPER" },
    { value: "START", label: "START" },
    { value: "other", label: "Altro" },
  ];

  // New options specifically for Mystery Client
  const MCClientOptions = [
    { value: "ASPO", label: "ASPO Mystery Client" },
    { value: "SETA", label: "SETA Mystery Client" },
    { value: "CTM", label: "CTM Mystery Client" },
    { value: "ATM", label: "ATM Mystery Client" },
    { value: "ATB", label: "ATB Mystery Client" },
    { value: "STPS", label: "STPS Mystery Client" },
    { value: "SGM", label: "SGM Mystery Client" },
    { value: "TPER", label: "TPER Mystery Client" },
    { value: "START", label: "START Mystery Client" },
    { value: "other", label: "Altro Mystery Client" },
  ];

  const SignalFixClientOptions = [
    { value: "ASPO", label: "ASPO SIGNAL_FIX_CLIENT" },
    { value: "SETA", label: "SETA SIGNAL_FIX_CLIENT" },
    { value: "CTM", label: "CTM SIGNAL_FIX_CLIENT" },
    { value: "ATM", label: "ATM SIGNAL_FIX_CLIENT" },
    { value: "ATB", label: "ATB SIGNAL_FIX_CLIENT" },
    { value: "STPS", label: "STPS SIGNAL_FIX_CLIENT" },
    { value: "SGM", label: "SGM SIGNAL_FIX_CLIENT" },
    { value: "TPER", label: "TPER SIGNAL_FIX_CLIENT" },
    { value: "START", label: "START SIGNAL_FIX_CLIENT" },
    { value: "other", label: "Altro SIGNAL_FIX_CLIENT" },
  ];

  const SimlFixClientOptions = [
    { value: "Bergamo", label: "Bergamo" },
    { value: "Lavagna", label: "Lavagna" },
    { value: "pietra_ligure", label: "Pietra Ligure" },
  ];

  const allInOneServicesOptions = [
    { value: "fcd_network", label: "FCD Network" },
    { value: "simfix_areas", label: "SIMFIX Areas" },
    { value: "predict", label: "Predict" },
    { value: "tl_green_wave", label: "TL Green Wave" },
    { value: "signalfix", label: "SignalFix" },
    { value: "od_analysis", label: "OD Analysis" },
    { value: "assignx", label: "Assignx" },
  ];

  const traffixClientOptions = [
    { value: "Bergamo", label: "Bergamo" },
    { value: "lavagna", label: "Lavagna" },
    { value: "saronno", label: "Saronno" },
    { value: "pietra_ligure", label: "Pietra Ligure" },

  ];

  useEffect(() => {
    const fetchMisteryVersions = async () => {
      try {
        const response = await fetchVersions();
        if (response.status === 200) {
          setMisteryVersion(response.data);
        } else {
          console.error(
            "Error fetching mystery versions:",
            response.statusText
          );
        }
      } catch (error) {
        console.error("Error fetching mystery versions:", error);
      }
    };

    fetchMisteryVersions();
  }, []);

  // Popolamento form
  useEffect(() => {
    if (open) {
      form.resetFields();
      setShowOtherClientInput(false);
      setShowMCVersion(false);
      setShowMCClient(false);
      setShowSignalFixClient(false);
      setShowSimFixClient(false);
      setShowAllInOneServices(false);
    }
  }, [form, open]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      // Handle custom client
      if (values.custom_client) {
          values.client = values.custom_client;
      }
      
      await registerUser(values);
      message.success("Utente aggiunto con successo");
      refreshUsers();
      onCancel();
    } catch (error) {
      console.error("Errore aggiunta utente:", error);
      message.error(
        error.response?.data?.message || error.response?.data?.error || "Errore nell'aggiunta dell'utente"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <div className="update-user-modal">
      <Modal
        open={open}
        title={
          <div className="admin-modal-title">
            <UserOutlined />
            Aggiungi Utente
          </div>
        }
        className="admin-modal"
        onCancel={handleCancel}
        width={800}
        footer={[
          <Button
            key="cancel"
            size="large"
            onClick={handleCancel}
            disabled={loading}
            className="admin-form-button-cancel"
          >
            Annulla
          </Button>,
          <Button
            key="submit"
            type="primary"
            size="large"
            onClick={handleSubmit}
            loading={loading}
            className="admin-form-button-primary"
          >
            Aggiungi
          </Button>,
        ]}
      >
        <Card bordered={false} className="admin-form-card">
          <Form
            form={form}
            layout="vertical"
            size="large"
          >
            <Row gutter={[16, 16]}>
              {/* Informazioni Personali */}
              <Col xs={24}>
                <div className="form-section-title">Informazioni Personali</div>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="first_name"
                  label="Nome"
                  rules={[
                    { required: true, message: "Il nome è obbligatorio" },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined />}
                    placeholder="Inserisci il nome"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="last_name"
                  label="Cognome"
                  rules={[
                    { required: true, message: "Il cognome è obbligatorio" },
                  ]}
                >
                  <Input
                    prefix={<UserOutlined />}
                    placeholder="Inserisci il cognome"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="gender"
                  label="Genere"
                  rules={[
                    { required: true, message: "Il genere è obbligatorio" },
                  ]}
                >
                  <Select placeholder="Seleziona genere">
                    <Option value="male">Maschio</Option>
                    <Option value="female">Femmina</Option>
                    <Option value="other">Altro</Option>
                  </Select>
                </Form.Item>
              </Col>

              {/* Informazioni di Contatto */}
              <Col xs={24}>
                <div className="form-section-title">
                  Informazioni di Contatto
                </div>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    { required: true, message: "L'email è obbligatoria" },
                    { type: "email", message: "Inserisci un'email valida" },
                  ]}
                >
                  <Input
                    prefix={<MailOutlined />}
                    placeholder="esempio@email.com"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="number"
                  label="Numero di Telefono"
                  rules={[
                    {
                      required: true,
                      message: "Il numero di telefono è obbligatorio",
                    },
                  ]}
                >
                  <Input
                    prefix={<PhoneOutlined />}
                    placeholder="Inserisci numero di telefono"
                  />
                </Form.Item>
              </Col>
              
              {/* Autenticazione */}
              <Col xs={24}>
                <div className="form-section-title">Autenticazione</div>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    { required: true, message: "La password è obbligatoria" },
                    { min: 6, message: 'La password deve contenere almeno 6 caratteri!' }
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="Inserisci password"
                  />
                </Form.Item>
              </Col>
              
              <Col xs={24} sm={12}>
                <Form.Item
                  name="confirmPassword"
                  label="Conferma Password"
                  dependencies={['password']}
                  rules={[
                    { required: true, message: "Conferma la password!" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Le password non corrispondono!'));
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="Conferma password"
                  />
                </Form.Item>
              </Col>


              <Col xs={24}>
                <Form.Item
                  name="address"
                  label="Indirizzo"
                >
                  <Input
                    prefix={<HomeOutlined />}
                    placeholder="Inserisci indirizzo completo"
                  />
                </Form.Item>
              </Col>

              {/* Informazioni Aziendali */}
              <Col xs={24}>
                <div className="form-section-title">Informazioni Aziendali</div>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="company"
                  label="Azienda"
                  rules={[{ required: true, message: 'L\'azienda è obbligatoria!' }]}
                >
                  <Input 
                    placeholder="Inserisci azienda"
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="status"
                  label="Stato"
                  rules={[
                    { required: true, message: "Lo stato è obbligatorio" },
                  ]}
                >
                  <Select placeholder="Seleziona stato">
                    <Option value="approved">Approvato</Option>
                    <Option value="pending">In Attesa</Option>
                    <Option value="rejected">Rifiutato</Option>
                  </Select>
                </Form.Item>
              </Col>
              
              {/* Permessi */}
              <Col xs={24}>
                <Form.Item name="permissions" label="Permessi">
                  <Select
                    mode="multiple"
                    allowClear
                    placeholder="Seleziona permessi"
                    className="form-select-full"
                    options={permissions}
                    onChange={(value) => {
                      setShowMCVersion(value.includes("mystery_client"));
                      setShowMCClient(value.includes("mystery_client"));
                      setShowSignalFixClient(value.includes("signal_fix"));
                      setShowSimFixClient(value.includes("sim_fix"));
                      setShowAllInOneServices(value.includes("traffix_all_in_one"));
                    }}
                  ></Select>
                </Form.Item>
              </Col>
              <Card title="Dati Permessi" className="permission-card">
                <Row gutter={[16, 16]} className="permission-row">
                  {/* Mystery Client Fields */}
                  {showMCClient && (
                    <>
                      <Col xs={24}>
                        <Form.Item
                          name="mc_version"
                          label="Versione MysteryX"
                          rules={[
                            {
                              required: true,
                              message: "Seleziona la versione per MysteryX!",
                            },
                          ]}
                        >
                          <Select
                            mode="multiple"
                            allowClear
                            options={misteryVersion.map((version) => ({
                              value: version.version,
                              label: version.version,
                            }))}
                            placeholder="Seleziona versione MysteryX"
                            className="form-select-full"
                          ></Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24}>
                        <Form.Item
                          name="client"
                          label="Cliente MysteryX"
                          rules={[
                            {
                              required: true,
                              message: "Seleziona il cliente MysteryX!",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Seleziona il cliente MysteryX"
                            options={clientOptions}
                            className="auth-select"
                            suffixIcon={<TeamOutlined className="input-icon" />}
                            onChange={(value) => {
                              setShowOtherClientInput(value === "other");
                              if (value !== "other") {
                                form.setFieldsValue({
                                  custom_client: undefined,
                                });
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                      {showOtherClientInput && (
                        <Col xs={24} >
                          <Form.Item
                            name="custom_client"
                            label="Nome Cliente Personalizzato"
                            rules={[
                              {
                                required: true,
                                message: "Inserisci il nome del cliente!",
                              },
                            ]}
                          >
                            <Input
                              prefix={<TeamOutlined />}
                              placeholder="Inserisci nome cliente"
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </>
                  )}

                  {/* Signal Fix Fields */}
                  <Col xs={24}>
                    {showSignalFixClient && (
                      <Form.Item
                        name={"signal_fix_client"}
                        label="Cliente SignalFix"
                        rules={[
                          {
                            required: true,
                            message: "Seleziona il cliente per SignalFix!",
                          },
                        ]}
                      >
                        <Select
                          mode="multiple"
                          allowClear
                          className="form-select-full"
                          options={SignalFixClientOptions}
                          placeholder="Seleziona cliente SignalFix"
                        ></Select>
                      </Form.Item>
                    )}
                  </Col>

                  {/* Sim Fix Fields */}
                  <Col xs={24}>
                    {showSimFixClient && (
                      <Form.Item
                        name={"sim_fix_client"}
                        label="Client Sim Fix"
                        rules={[
                          {
                            required: true,
                            message: "Seleziona il cliente per SimFix!",
                          },
                        ]}
                      >
                        <Select
                          className="form-select-full"
                          mode="multiple"
                          allowClear
                          options={SimlFixClientOptions}
                          placeholder="Seleziona cliente SimFix"
                        ></Select>
                      </Form.Item>
                    )}
                  </Col>

                  {/* Traffix All In One Services */}
                  <Col xs={24}>
                    {showAllInOneServices && (
                      <Form.Item
                        name={"all_in_one_services"}
                        label="All In One Services"
                        rules={[
                          {
                            required: true,
                            message: "Seleziona almeno un servizio!",
                          },
                        ]}
                      >
                        <Select
                          className="form-select-full"
                          mode="multiple"
                          allowClear
                          options={allInOneServicesOptions}
                          placeholder="Seleziona i servizi All In One"
                        ></Select>
                      </Form.Item>
                    )}
                  </Col>

                  {/* Traffix Client */}
                  <Col xs={24}>
                    {showAllInOneServices && (
                      <Form.Item
                        name={"traffix_client"}
                        label="Traffix Client"
                        rules={[
                          {
                            required: true,
                            message: "Seleziona almeno un client!",
                          },
                        ]}
                      >
                        <Select
                          className="form-select-full"
                          mode="multiple"
                          allowClear
                          options={traffixClientOptions}
                          placeholder="Seleziona i client Traffix"
                        ></Select>
                      </Form.Item>
                    )}
                  </Col>
                </Row>
              </Card>
            </Row>
          </Form>
        </Card>
      </Modal>
    </div>
  );
}

export default AddUser;
